import React from 'react';
import DeliverySettings from '../../components/DeliverySettings';

const JustEat = () => {
	return <DeliverySettings channelId="just-eat" />;
};

export default JustEat;
